import {
  ReactElementFactory,
  SurveyQuestionCheckboxItem,
} from "survey-react-ui";
import * as Checkbox from "@radix-ui/react-checkbox";
import { createElement } from "react";
import classNames from "classnames";
import * as Icon from "../icons";
import { AppIcon } from "../atoms";

class BorderedCheckboxItem extends SurveyQuestionCheckboxItem {
  handleOnChange = (checked: boolean) => {
    if (
      !this.question.isReadOnly &&
      this.item.isEnabled &&
      this.question.page.name !== "all"
    )
      this.props.question.clickItemHandler(this.props.item, checked);
  };

  handleLabelClick = () => {
    const isEnabled = this.item.isEnabled && this.question.page.name !== "all";
    if (isEnabled) this.handleOnChange(!this.item.selected);
  };

  render() {
    const { item, question } = this.props;
    const itemData = item.data ?? {};
    const disabled =
      this.question.isReadOnly ||
      !item.isEnabled ||
      question.page.name === "all";
    return (
      <div className="flex items-center gap-2.5 mb-5">
        <Checkbox.Root
          disabled={disabled} //all = preview page
          checked={item.selected}
          name={item.name}
          value={item.value}
          onCheckedChange={this.handleOnChange}
          className="hidden group"
        />
        <div
          className={classNames(
            "flex items-center gap-[15px] py-[14px] px-[15px] md:px-4 w-full h-[3.75rem] shrink-0 border border-indigo-100 rounded-[10px] cursor-pointer",
            {
              "!cursor-default": disabled,
              "!bg-gray-50 !border-gray-300": disabled && !item.selected,
              "bg-indigo-500 border-indigo-500": item.selected,
            }
          )}
          onClick={this.handleLabelClick}
        >
          {itemData.icon ? (
            <AppIcon
              name={itemData.icon}
              size={30}
              color={
                item.selected
                  ? "white"
                  : disabled
                  ? "var(--gray-300)"
                  : "var(--gray-400)"
              }
            />
          ) : (
            <ItemIcon
              value={this.item.value}
              size={30}
              color={
                this.item.selected
                  ? "white"
                  : disabled
                  ? "var(--gray-300)"
                  : "var(--gray-400)"
              }
            />
          )}
          <label
            className={classNames(
              "text-sm font-medium whitespace-normal text-ellipsis overflow-hidden leading-5",
              disabled ? "text-gray-300" : "text-gray-800 cursor-pointer",
              {
                "text-white": item.selected,
              }
            )}
          >
            {item.title}
          </label>
        </div>
      </div>
    );
  }
}

ReactElementFactory.Instance.registerElement(
  "borderd-checkbox-item",
  (props) => {
    return createElement(BorderedCheckboxItem, props);
  }
);

function ItemIcon({ value, ...other }: { value: string } & Icon.IconProps) {
  switch (value) {
    // Bio
    case "BIOMASS":
    case "BIODIESEL":
    case "Biomass":
    case "Biodiesel":
      return <Icon.Bio {...other} />;

    // Coal
    case "COAL":
    case "Coal":
      return <Icon.Coal {...other} />;

    // Oil
    case "DIESEL":
    case "PETROL":
    case "FUEL_OIL":
    case "Diesel":
    case "Petrol":
    case "Fuel Oil":
      return <Icon.Oil {...other} />;

    // Wind
    case "PURCHASED_STEAM":
    case "ON_SITE_WIND_ELECTRICTY":
    case "Purchased Steam":
    case "On-site Wind Electricty":
      return <Icon.Wind {...other} />;

    // Zap (Electricity)
    case "PURCHASED_ELECTRICITY":
    case "PURCHASED_ELECTRICITY_RENEWABLE":
    case "Purchased Electricity":
    case "Purchased Electricity (Renewable)":
      return <Icon.Zap {...other} />;

    // Sun (Solar)
    case "ON_SITE_SOLAR_ELECTRICTY":
    case "On-site Solar Electricty":
      return <Icon.Sun {...other} />;

    // Water (Chilled or Hot)
    case "PURCHASED_CHILLED_WATER":
    case "PURCHASED_HOT_WATER":
    case "Purchased Chilled Water":
    case "Purchased Hot Water":
      return <Icon.Water {...other} />;

    // Droplet (Various water sources)
    case "FRESH_SURFACE_WATER":
    case "RAINWATER_COLLECTION":
    case "GROUNDWATER_WATER_WELL":
    case "MUNICIPAL_WATER_SUPPLY":
    case "RECYCLED_WATER_PRODUCED_PROCESS_WATER":
    case "WATER_TRUCK_DELIVERY_GENERAL_OR_UNKNOWN_ORIGIN":
    case "WASTEWATER_FROM_ANOTHER_ORGANIZATION":
    case "BRACKISH_SURFACE_WATER_SEAWATER":
    case "Fresh Surface Water":
    case "Rainwater collection":
    case "Groundwater (water well)":
    case "Municipal water supply":
    case "Recycled water (Produced/Process Water)":
    case "Water truck delivery (general or unknown origin)":
    case "Wastewater from another organization":
    case "Brackish surface water/seawater":
      return <Icon.Droplet {...other} />;

    // Gas
    case "NATURAL_GAS":
    case "LIQUIFIED_NATURAL_GAS_LNG":
    case "LIQUEFIED_PETROLEUM_GAS_LPG":
    case "COMPRESSED_NATURAL_GAS_CNG":
    case "Natural Gas":
    case "Liquified Natural Gas (LNG)":
    case "Liquefied Petroleum Gas (LPG)":
    case "Compressed natural gas (CNG)":
      return <Icon.Gas {...other} />;

    // Wood
    case "WOOD":
    case "Wood":
      return <Icon.Wood {...other} />;

    // Other
    case "OTHER":
    case "Other":
      return <Icon.MoreHorizontal {...other} />;

    default:
      return null;
  }
}
